import { canInsertInlineIn } from '@gitbook/doc-core';

import { createTypePlugin } from '../type-plugin';
import { InlineControlsPicker } from './InlineControlsPicker';
import { INLINE_CONTROLS, type InlineControlsMarkData } from './types';

/**
 * Slate plugin to detect user typing "/".
 */
export const inlineControlsPlugin = createTypePlugin<InlineControlsMarkData>({
    symbols: ['/'],
    markType: 'inlineControlsContext',
    getData: ({ value, textValue }) => {
        const { document, startBlock } = value;
        if (!startBlock) {
            return null;
        }
        const controls = INLINE_CONTROLS.filter((control) =>
            canInsertInlineIn({ document, block: startBlock }, control)
        );
        if (controls.length === 0) {
            return null;
        }
        return { value: textValue, controls };
    },
    renderMark: (props) => {
        return <InlineControlsPicker {...props} />;
    },
});
